module.exports = __webpack_public_path__ + "static/media/06.114.1be162fa.webp";